export default __webpack_public_path__ + "static/media/default-image-rectangle.50df180d.svg";